import { Suspense, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import LocalStorage from 'utils/bom-dom-manipulation/local-storage';
import { arrayFindBy } from 'utils/collection-manipulation/array-find-by';
import { ReservedRoutes } from 'utils/constants/app/app-routes';
import { ODD_FORMATS } from 'utils/constants/betslip/odd-formats';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { lazy as lazyImport } from 'utils/generic/lazy';
import { storageKeyName } from 'utils/generic/storage-key-name';
import { useChangeOddFormat } from 'hooks/betslip/useChangeOddFormat';
import { useSearchParams } from 'hooks/useSearchParams';

const { AddToBetslipLink } = lazyImport(
  () =>
    import(
      /* webpackChunkName: "add-to-betslip-link" */ 'components/AddToBetslipLink'
    )
);

export const AddToBetslipLinkCheck = () => {
  const queries = useSearchParams();
  const location = useLocation();
  const changeOddFormat = useChangeOddFormat();

  const [isAddToBetslip, setIsAddToBetslip] = useState(false);

  useEffect(() => {
    if (SpringConfigs.IFRAME_SPORTSBOOK && queries.odds_type) {
      const format = {
        ...arrayFindBy(ODD_FORMATS, 'value', queries.odds_type, false)
      };

      const { id, value } = format;
      changeOddFormat(id, value);
    }

    if (
      location.pathname === ReservedRoutes.addToBetslip ||
      location.pathname.includes(`${ReservedRoutes.addToBetslip}/`) ||
      LocalStorage.getItem(storageKeyName('betslip', 'ADD_TO_BETSLIP_DATA'))
    ) {
      setIsAddToBetslip(true);
    }

    if (location.pathname.includes(ReservedRoutes.deposit)) {
      const path = location.pathname.replace(ReservedRoutes.deposit, '');
      window.location.href = `${window.location.origin}${path}?accounts=%2A&wallet=%2A&deposit=%2A`;
    }
  }, []);

  if (!isAddToBetslip) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <AddToBetslipLink />
    </Suspense>
  );
};
